<div class="iframe-section">
  <div class="container px-6 px-md-0">
    <iframe style="width: 100%; display: block; height: 555px;"
            [src]="getUrl()">
    </iframe>
  </div>
</div>

